// Export barrel for SalesManager components
import SalesManager from './SalesManager';
export default SalesManager;
export { SalesProvider, useSales } from './SalesContext';
export { default as ErrorBoundary } from './shared/ErrorBoundary';
export { LoadingSkeleton } from './shared/LoadingSkeleton';
export { EmptyState } from './shared/EmptyState';
export * from './types';

